/* eslint-disable no-console */
/* eslint-disable camelcase */
/* eslint-disable no-lonely-if */
/* eslint-disable no-negated-condition */
/* eslint-disable arrow-parens */
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import bindAll from 'lodash.bindall';
import isEmpty from "lodash/isEmpty";
import AixiongSerialport from './aixiong-serialport.jsx';
import io from 'socket.io-client';

import { connect } from 'react-redux';
import { showAlertWithAixiong, closeAlertWithId } from '../../reducers/alerts';
import { setBurnResult, setSocket, setAdaptor, setBurning, setGuiTovm, setMySocket } from '../../reducers/code';

const buff2str = (ab) => String.fromCharCode.apply(null, new Uint8Array(ab))

let socket = null;
let mySocket = null;

class AixiongSocketClient extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            'handleXxx',
            'handleConnecting',
            'handleUploadCode',
            'handleRestoreFirmware'
        ]);
        this.state = {
            isSocketConnected: false, // 用户是否连接了爱熊客户端
            serialportList: [], // 用户连接本地客户端后可用的端口连接列表
            connectedPort: null, // 用户连接成功的外设端口
            selectedPortIndex: -1,
            btnStatus: 1,
            btnStr: '连接硬件',
            serialport_error: false,
            aibear_firmata: false,
            aibear_firmata_connecting: false,
            handpyFlashProgress: '0%', // 掌控板上传代码进度
            handpyFlashStatus: false,
            //     case 2 btnStr = '正在连接'
            //     case 3 btnStr = '连接成功'
        };
    }

    connectSocket() {
        const { setMySocket } = this.props
        const domain = location._query['domain'] ? location._query['domain'] : 'https://teacher.e-ai-edu.com'
        const socketOriginUrl = (domain.indexOf("qa") > -1 || domain.indexOf("localhost") > -1) ? 'https://qa-ws.e-ai-edu.com' : 'https://ws.e-ai-edu.com'
        const userInfor = JSON.parse(sessionStorage.getItem('userInfor'));
        const role = userInfor.role;
        let event_type = `scratch3_connect_t`

        if (role && (role[0] == 9 || role[0] == 10)) {
            event_type = `scratch3_connect_s`
        }

        mySocket = io(socketOriginUrl, { transports: ['websocket'] });
        mySocket.on('connect', () => {
            console.log("socket on connect");
            mySocket.emit('reportListener', {
                userId: JSON.parse(sessionStorage.getItem('userInfor')).id,
                method: "scratch3",
                extra: {
                    path: location.href,
                    event_type,
                    event_name: '爱熊图形化编程连接',
                    domain
                }
            });
            setMySocket(socket)
        });
        mySocket.on('disconnect', () => {
            console.log('socket on disconnect')
            setMySocket(null)
        });
        mySocket.on('connect_error', (error) => {
            console.log('socket on connect_error', error);
            setMySocket(null)
        });
    }

    componentDidMount() {
        const { setSocket, setAdaptor, setBurning, setGuiTovm, setBurnResult, onShowAixiongInfo, closeAixiongInfo } = this.props
        const _this = this
        // api https://socket.io/docs/client-api/#Event-%E2%80%98error%E2%80%99
        socket = io(`ws://localhost:13171/`, { path: '/extension/aibear', transports: ['websocket'] });
        // 连接状态判断
        socket.on('connect', () => {
            console.log("socket on connect");
            this.setState({
                isSocketConnected: true,
                serialportList: []
            })
            // 开始查找可用端口
            socket.emit('serialport_to_aibear');
            setSocket(socket)
        });
        socket.on('disconnect', () => {
            console.log('socket on disconnect')
            this.setState({
                isSocketConnected: false,
                serialportList: []
            })
            setSocket(null)
            setAdaptor(false)
        });
        socket.on('connect_error', (error) => {// 只要打开在线IDE就会一直尝试连接本地客户端，连接不上则回调connect_error方法
            console.log('socket on connect_error');
            this.setState({
                isSocketConnected: false,
                serialportList: []
            })
            setSocket(null)
            setAdaptor(false)
        });

        // 查找可用端口结果。只要客户端启动就一直回调这个接口。
        socket.on('serialport_to_aibear', (data) => {
            // console.log('可用端口和已连接端口:\n', data.data);
            this.setState({
                serialportList: data.data.serialport_list,
                serialport_error: data.data.serialport_error,
                aibear_firmata: data.data.aibear_firmata,
                aibear_firmata_connecting: data.data.aibear_firmata_connecting,
            });
            // <p>
            //     <strong>端口状态：</strong>
            //     <span v-html="serialport_error ? '端口阻塞, 请刷新程序' : '端口正常'"></span>
            // </p>
            // <p>
            //     <strong>端口通信状态：</strong>
            //     <span v-html="aibear_firmata ? '已连接' : '未连接'"></span>
            // </p>
            if (data.data.serialport && !isEmpty(data.data.serialport)) {
                // 连接成功
                // console.log('连接成功\n', data.data.serialport);
                let portStringList = data.data.serialport_list.map(port => port.path);
                this.setState({
                    connectedPort: data.data.serialport,
                    selectedPortIndex: portStringList.indexOf(data.data.serialport.path)
                });
            } else {
                this.setState({
                    connectedPort: null,
                    selectedPortIndex: null
                });
            }

            const { serialport_error, aibear_firmata, connectedPort, aibear_firmata_connecting } = this.state

            if (!connectedPort) {
                if (serialport_error) {
                    setAdaptor(false)
                    setBurning(false)
                    this.setState({
                        btnStatus: 4,
                        btnStr: '超时请刷新'
                    })
                } else {
                    this.setState({
                        btnStatus: 1,
                        btnStr: '通信连接'
                    })
                    setAdaptor(false)
                }

            } else {
                if (serialport_error) {
                    setAdaptor(false)
                    setBurning(false)
                    this.setState({
                        btnStatus: 4,
                        btnStr: '超时请刷新'
                    })
                } else if (aibear_firmata) {
                    setAdaptor(true)
                    setBurning(false)
                    this.setState({
                        btnStatus: 3,
                        btnStr: '通信连接'
                    })
                } else if (aibear_firmata_connecting) {
                    setAdaptor(false)
                    setBurning(true)
                    this.setState({
                        btnStatus: 2,
                        btnStr: '正在建立通信连接......'
                    })
                } else {
                    setAdaptor(false)
                    setBurning(false)
                    this.setState({
                        btnStatus: 1,
                        btnStr: '通信连接'
                    })
                }
            }
        });

        // 代码上传结果回调
        socket.on('uploading_to_aibear', (data) => {
            // console.log('上传结果\n', data.data)
            setBurnResult(data.data)
            // console.log(data.data.status == '正在烧录')
            if (data.data.status == '正在烧录') {
                setBurning(true)
            } else {
                setBurning(false)
                closeAixiongInfo()
            }
            if (data.data.msg) {
                // console.log(data.data)
                onShowAixiongInfo({
                    maxDisplaySecs: 5,
                    // message: 'hahaha',
                    closeButton: true,
                    content: <span>{data.data.msg}</span>,
                    iconSpinner: true
                });
            }
        });

        let restoreResult = ''

        socket.on('esp32_to_scratch3_gui', (data) => {
            if (data.method == 'resend') {
                const result = data.data
                // console.log('resend: ', result)
                if (result.type == 'flashPy') {
                    _this.setState({ handpyFlashProgress: result.data })
                }
                if (result.type == 'status') {
                    _this.setState({
                        handpyFlashStatus: result.data,
                        handpyFlashProgress: '0%'
                    })
                }
            }
            if (data.method == 'restore') {
                // console.log('掌控板上传结果\n', data)
                // console.log('restore: ', buff2str(data.data))
                let str = buff2str(data.data)
                // Writing at 0x00190000... (99 %)

                if ((/Writing.*%/ig).test(str)) {
                    let numStr = str.match(/\(.*%\)/ig)
                    numStr = numStr[0]
                    numStr = numStr.replace(/\(|\)/ig, '')
                    let num = parseInt(numStr)
                    // console.log('当前进度', num)
                    _this.setState({ handpyFlashProgress: num + '%' })
                }
                if (str.indexOf('Connecting...') !== -1) {
                    restoreResult = str
                } else {
                    restoreResult += '\n'
                    restoreResult += str
                }
                setBurnResult({
                    // status: true
                    message: restoreResult
                })
            }
            if (data.method == 'transition') {
                // console.log('transition: ', data.data)
                restoreResult += '\n'
                restoreResult += data.data
                setBurnResult({
                    message: restoreResult
                })
            }
            // onShowAixiongInfo({
            //     maxDisplaySecs: 5,
            //     // message: 'hahaha',
            //     closeButton: true,
            //     content: <span>{data.data.msg}</span>,
            //     iconSpinner: true
            // });
        });

        // socket.on('trans_from_aibear', (data) => {
        //     console.log('交互模式状态\n', data.data)
        //     // btnStatus
        // });

        setTimeout(() => {
            this.connectSocket();
        }, 5000);

    }
    componentWillUnmount() {
        if (socket) {
            socket.close();
        }
        if (mySocket) {
            mySocket.close();
        }
    }
    handleXxx() {
        console.log('handleXxx');
    }
    handleConnecting(i, port) {
        console.log('handleConnecting', i, port);
        // 用户选择连接的端口
        socket.emit('serialport_from_aibear', { path: port.path });
    }
    handleUploadCode(isHandpy) {
        const { runMode, onShowAixiongInfo, setAdaptor, setBurning, setGuiTovm } = this.props
        const { btnStatus, btnStr, connectedPort } = this.state
        if (btnStatus == 4) {
            socket.emit('trans_from_scratch3', {
                method: 'adaptor_restart', // 'arduino_firmata',
                params: {}
            });
            this.setState({
                btnStatus: 1,
                btnStr: '连接硬件'
            })
            return;
        }
        if (!connectedPort) {
            onShowAixiongInfo({
                maxDisplaySecs: 5,
                // message: 'hahaha',
                closeButton: true,
                content: <span>{'请先连接硬件'}</span>,
                iconSpinner: true
            });
        }
        if (runMode == 1) {
            // btnStatus = 1 upload
            // btnStatus = 2 waiting
            // btnStatus = 3 ok
            // this.setState({
            //     btnStatus: 2
            // })
            if (btnStatus == 1) {
                socket.emit('trans_from_scratch3', {
                    method: 'firmata_connect', // 'arduino_firmata',
                    params: {}
                });
                setAdaptor(false)
                setBurning(true)
                this.setState({
                    btnStatus: 2,
                    btnStr: '正在建立通信连接......'
                })
            } else if (btnStatus == 4) {
                if (btnStr == '超时请刷新') {
                    socket.emit('trans_from_scratch3', {
                        method: 'adaptor_restart', // 'arduino_firmata',
                        params: {}
                    });
                    this.setState({
                        btnStatus: 1,
                        btnStr: '连接硬件'
                    })
                }

            } else {

            }

        }
        // 模拟用户发送代码
        if (runMode == 0) {
            setGuiTovm({
                state: !this.props.guiTovm.state,
                method: 'brushCodeFn', // runCodeFn brushCodeFn
                data: this.props.code
            })
            // socket.emit ('code_from_arduino', {payload: this.props.code});
            console.log('开始上传代码', this.props.code);
        }

    }
    handleRestoreFirmware() {
        const { runMode } = this.props
        socket.emit('esp32_from_scratch3', {
            method: 'restore',
            data: { runMode }
        })
        socket.emit('esp32_from_scratch3', {
            method: 'resend',
            data: {
                type: 'status',
                data: true
            }
        })
    }
    handleReload() {
        socket.emit('restart_from_scratch', {
            method: 'reload',
            params: {}
        });
    }
    handleRelaunch() {
        socket.emit('restart_from_scratch', {
            method: 'relaunch',
            params: {}
        });
    }

    render() {
        const { handpyFlashProgress, handpyFlashStatus } = this.state
        return (
            <React.Fragment>
                <AixiongSerialport
                    isSocketConnected={this.state.isSocketConnected}
                    serialportList={this.state.serialportList}
                    connectedPort={this.state.connectedPort}
                    selectedPortIndex={this.state.selectedPortIndex}
                    btnStatus={this.state.btnStatus}
                    btnStr={this.state.btnStr}
                    // isSocketConnected = {true}
                    // serialportList = {[1,2]}
                    // connectedPort = {1}
                    // selectedPortIndex = {0}
                    handleConnecting={this.handleConnecting}
                    handleUploadCode={this.handleUploadCode}
                    handleRestoreFirmware={this.handleRestoreFirmware}
                    handleReload={this.handleReload}
                    handleRelaunch={this.handleRelaunch}
                    runMode={this.props.runMode}
                    showCompetition={this.props.showCompetition}
                />
                {handpyFlashStatus && <div
                    style={{
                        position: 'fixed',
                        left: 0,
                        top: 0,
                        background: 'rgba(0, 0, 0, 0.3)',
                        width: '100%',
                        height: '100vh',
                    }}
                >
                    <div
                        className='progress'
                        style={{
                            width: '50vw',
                            height: '20px',
                            position: 'absolute',
                            left: '50%',
                            top: '50%',
                            transform: 'translate(-50%, -50%)',
                            background: '#ebebeb',
                            borderRadius: '10px',
                        }}
                    >
                        <span
                            style={{
                                width: handpyFlashProgress,
                                position: 'relative',
                                float: 'left',
                                margin: 0,
                                height: '20px',
                                paddingRight: '2px',
                                minWidth: '30px',
                                lineHeight: '20px',
                                textAlign: 'right',
                                background: '#f28c2c',
                                borderRadius: '10px',
                                transition: 'all 0.3s',
                            }}
                        >
                            {handpyFlashProgress}
                        </span>
                    </div>
                </div>}
            </React.Fragment>


        );
    }
}

AixiongSocketClient.propTypes = {
    setBurnResult: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    code: state.scratchGui.code.code,
    runMode: state.scratchGui.mode.runMode,
    guiTovm: state.scratchGui.code.guiTovm,
});

const mapDispatchToProps = dispatch => ({
    setBurnResult: (burnResult) => {
        dispatch(setBurnResult(burnResult))
    },
    setSocket: (socket) => {
        dispatch(setSocket(socket))
    },
    setMySocket: (mySocket) => {
        dispatch(setMySocket(mySocket))
    },
    setAdaptor: (adaptor) => {
        dispatch(setAdaptor(adaptor))
    },
    setBurning: (burning) => {
        dispatch(setBurning(burning))
    },
    setGuiTovm: (guiTovm) => {
        dispatch(setGuiTovm(guiTovm))
    },

    onShowAixiongInfo: data => showAlertWithAixiong(dispatch, data),
    closeAixiongInfo: () => {
        dispatch(closeAlertWithId('aixiongInfo'))
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AixiongSocketClient);
